<div class="section-wrapper">
  <div class="section-wrapper-background">
    <video autoplay loop webkit-playsinline="true" playsinline="true">
      <source src="assets/video/weave_wave.mp4" type="video/mp4" />
    </video>
  </div>
  <div class="container">
    <div class="mini-title">{{ "COMPANY.LANDING.MINI_TITLE" | translate }}</div>
    <div class="title company-landing">
      <span class="text-wrapper">{{
        "COMPANY.LANDING.TITLE" | translate
      }}</span>
    </div>

    <div class="vm-container">
      <div class="vision" id="vision_mission">
        <h1 class="vm-title">
          <span class="text-wrapper">{{
            "COMPANY.VISION.TITLE" | translate
          }}</span>
        </h1>
        <div class="subdescription">
          {{ "COMPANY.VISION.DESCRIPTION" | translate }}
        </div>
      </div>
      <div class="mission">
        <h1 class="vm-title">
          <span class="text-wrapper">{{
            "COMPANY.MISSION.TITLE" | translate
          }}</span>
        </h1>
        <ul class="mission-list">
          <li>
            <div class="img-wrapper">
              <img src="assets/img/icon_fiberoptic.png" />
            </div>
            {{ "COMPANY.MISSION.LIST_ITEM1" | translate }}
          </li>
          <li>
            <div class="img-wrapper">
              <img src="assets/img/icon_connectivity.png" />
            </div>
            {{ "COMPANY.MISSION.LIST_ITEM2" | translate }}
          </li>
          <li>
            <div class="img-wrapper">
              <img src="assets/img/icon_people.png" />
            </div>
            {{ "COMPANY.MISSION.LIST_ITEM3" | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
